import create from 'zustand';
import {subscribeWithSelector} from 'zustand/middleware';

export const PlayState = {
  Stopped: 0,
  Playing: 1,
  Paused: 2
};

const animationStore = create(subscribeWithSelector((set, get) => ({
  clips: [],
  clipStates: [],

  setSceneAnimations: (clips) => {
    set({
      clips: clips,
      clipStates: clips.map(clip => ({clipName: clip.name, playState: PlayState.Stopped}))
    });
  },

  toggleClipActivation: (clipToToggle) => {
    const nextClipStates = get().clipStates
      .map(clipState => Object.assign({}, clipState, {
          playState:
            (clipState.clipName === clipToToggle.name) ? 1 - clipState.playState : clipState.playState
        })
      );
    set({clipStates: nextClipStates});
  },

  setClipProgression: (clipName, progression) => {
    const nextClipStates = get().clipStates
      .map(clipState => Object.assign({}, clipState, {
          progression:
            (clipState.clipName === clipName) ? progression : clipState.progression
        })
      );
    set({clipStates: nextClipStates});
  },
})));

export {animationStore};
